import React from 'react';
import UserManagement from '../features/users/components/UserManagement';

const UsersManagmentPage = () => {
  return <UserManagement />;
};

export default UsersManagmentPage;